import { Slide } from "@jelly/lesson";
import config from "appConfig";

const segmentsInOrder = ["tfl", "tfc", "tfr", "tbr", "tbc", "tbl", "bfl", "bfc", "bfr", "bbr", "bbc", "bbl"];
const soundMap: Record<string, string> = {};

for (let groupIndex = 0; groupIndex < 3; groupIndex++) {
  segmentsInOrder.forEach((segment, index) => {
    const key = [groupIndex, segment].join(",");
    const asset =
      `${config.ASSETS_URL}/02/case02/HRTF${(groupIndex + 1).toString().padStart(2, "0")}_` +
      (index + 1).toString().padStart(2, "0") +
      `${groupIndex === 0 ? "" : "_norm"}` +
      ".wav";
    soundMap[key] = asset;
  });
}

const principle: Slide = {
  title: "Experiment",
  layout: {
    type: "customCase020202",
    options: {
      soundMap,
    },
  },
};

export default principle;
